
import { Instagram } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DiscordIcon, KickIcon, XIcon } from "@/components/icons/CustomIcons";

const SocialLinks = () => {
  const socialLinks = [
    {
      icon: XIcon,
      href: "https://x.com/Striveleague",
      label: "X",
    },
    {
      icon: Instagram,
      href: "https://instagram.com/Strive_League",
      label: "Instagram",
    },
    {
      icon: DiscordIcon,
      href: "https://discord.gg/striveleague",
      label: "Discord",
    },
    {
      icon: KickIcon,
      href: "https://kick.com/Striveleague",
      label: "Kick",
    },
  ];

  return (
    <div className="flex items-center space-x-4">
      {socialLinks.map((social) => (
        <Button
          key={social.label}
          variant="ghost"
          size="icon"
          className="hover:text-primary"
          asChild
        >
          <a
            href={social.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={social.label}
          >
            <social.icon className="h-5 w-5" />
          </a>
        </Button>
      ))}
    </div>
  );
};

export default SocialLinks;
